import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export function useTablePayment({ API, restaurantId, tableId, sessionId, requestId, enabled }) {
  const [payment, setPayment] = useState({ status: "waiting_staff" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const ready = !!(enabled && API && restaurantId && tableId && sessionId && requestId);

  const refresh = useCallback(async () => {
    if (!ready) return;
    try {
      const res = await axios.get(`${API}/public/table-assist/payment-status`, {
        params: { restaurant_id: restaurantId, table_id: tableId, session_id: sessionId, request_id: requestId },
      });
      setPayment(res.data || { status: "waiting_staff" });
    } catch (_) { /* preserve last confirmed state */ }
  }, [ready, API, restaurantId, tableId, sessionId, requestId]);

  useEffect(() => {
    if (!ready) return undefined;
    refresh();
    const timer = setInterval(refresh, 3000);
    return () => clearInterval(timer);
  }, [ready, refresh]);

  const pay = useCallback(async () => {
    if (!ready || loading) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/public/table-assist/payment-checkout`, {
        restaurant_id: restaurantId, table_id: tableId, session_id: sessionId,
        request_id: requestId, return_url: window.location.href,
      });
      if (res.data?.checkout_url) window.location.assign(res.data.checkout_url);
      else setPayment(res.data || payment);
    } catch (err) {
      setError(err?.response?.data?.detail || "No se pudo abrir el pago. Inténtalo de nuevo.");
    } finally { setLoading(false); }
  }, [ready, loading, API, restaurantId, tableId, sessionId, requestId, payment]);

  return { payment, loading, error, pay, refresh };
}
